export default __webpack_public_path__ + "487fc356898b520665b7682840ee90cd.svg";